




import { defineComponent } from "@vue/composition-api";
import alert from "@/components/misc/alert.vue";
export default defineComponent({
    name: "sidebarEditEmpty",
    components: { alert },
    props: {},
    setup(props, ctx) {},
});
